module.exports = __webpack_public_path__ + "static/ballantinesEF-3b37bc774f88697187687a1066b57a93.woff";